/** Strip a leading `@` and whitespace — stored usernames are never prefixed. */
export function normalizeUsernameInput(value: string): string {
	const trimmed = value.trim()
	if (!trimmed || trimmed === '—') return ''
	return trimmed.startsWith('@') ? trimmed.slice(1).trim() : trimmed
}

/** Display handle — `@username`, or em dash when missing. */
export function formatDisplayUsername(username: string | null | undefined): string {
	const normalized = normalizeUsernameInput(username ?? '')
	if (!normalized) return '—'
	return `@${normalized}`
}
